import http from '../utils/https';

export function getSignature(url) {
	return http.get('/api/common/createJsapiSignature', {
		params: {
			url
		}
	});
}
